
// Constants for post form functionality
export const MAX_CHARS = 500;

export type PostType = 'text' | 'image' | 'video' | 'link';
